import { render, staticRenderFns } from "./ListGamesCategories.vue?vue&type=template&id=f9d557aa&scoped=true"
import script from "./ListGamesCategories.vue?vue&type=script&lang=js"
export * from "./ListGamesCategories.vue?vue&type=script&lang=js"
import style0 from "./ListGamesCategories.vue?vue&type=style&index=0&id=f9d557aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d557aa",
  null
  
)

export default component.exports